// eslint-disable-next-line check-file/filename-blocklist
export enum WebViewPageTypes {
    Unknown = -1,
    Home = 910000,
    Search = 910001,
    Details = 910002,

    // Used the MobLoginOptions pageTypeId for webview because
    // 1. We do not have any dedicated pageTypeId for login page in webview
    // 2. User can not perform login into the webview.
    Login = 200127,
    BookingForm1 = 910004,
    BookingForm2 = 910005,
    ThankYou = 910006,
    PageNotFound = 910007,
    City = 910009,
    Country = 910010,
    Area = 910011,
    Region = 910012,
}
